import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { isSubscribed } from '../../../../user/userUtil';
import { isUnlimited } from '../../../../../common/users/contentLimit';
import { getDefaultContentLimit } from '../../../../../common/users/utils/userPropertyUtils';
import { isPlatformModernMobileApp } from '../../../../platform/utils/platformDetailsUtils';

// Selectors
import { getPlatformDetailsSelector } from '../../../../platform/platformSelector';

import ElectronLink from '../../../../components/electron/ElectronLink';

import { CHECKOUT_REFER_ROUTE } from '../../../../user/account/checkout/checkoutConstants';

import './ReferUtil.scss';

const ReferUtil = ({ currentUser }) => {
    if (isSubscribed(currentUser) || isUnlimited(getDefaultContentLimit(currentUser))) {
        return null;
    }

    const platformDetails = useSelector(getPlatformDetailsSelector);

    const hideReferLink = isPlatformModernMobileApp(platformDetails);

    if (hideReferLink) return null;

    return (
        <ElectronLink to={CHECKOUT_REFER_ROUTE} className="ReferUtil">
            Refer a friend, get more space &gt;
        </ElectronLink>
    );
};

ReferUtil.propTypes = {
    currentUser: PropTypes.object,
};

export default ReferUtil;
